import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import AnalyticsPage from 'bpm/pages/AnalyticsPage/AnalyticsPageContainer'
import SpecpointAnalyticsPage from 'bpm/pages/SpecpointAnalyticsPage'

export const AnalyticsPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/home',
    },
    '/legacy': {
        name: 'Legacy Analytics',
        component: AnalyticsPage,
    },
    '/home': {
        name: 'Specpoint Analytics',
        component: SpecpointAnalyticsPage,
    },
}
